import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, Pagination} from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import {Box} from "@mui/material";
import {sanitizeHtml} from "../../utils/sanitize.ts";

interface NewsItem {
    title: string;
    description: string;
}

const NewsSlider: React.FC = () => {
    const {t} = useTranslation();
    const newsItems: NewsItem[] = t("login.news.items", {returnObjects: true}) || [];
    const [currentIndex, setCurrentIndex] = useState(0);

    return (
        <Box sx={{
            ".swiper-pagination": {
                textAlign: "right",
                position: "relative"
            }
        }} className="relative w-full max-w-[600px] mx-auto overflow-hidden">
            <Swiper
                modules={[Autoplay, Pagination]}
                autoplay={{
                    pauseOnMouseEnter: true,
                    delay: 6000,
                }}
                onSlideChange={swiper => {
                    setCurrentIndex(swiper.activeIndex);
                }}
                initialSlide={currentIndex}
                className="min-h-[300px]"
                pagination={{
                    clickable: true,
                }}
                style={{
                    "--swiper-pagination-bullet-inactive-color": "white",
                    "--swiper-pagination-bullet-inactive-opacity": "0.5",
                    "--swiper-pagination-color": "rgba(253,205,067,1.00)",
                } as React.CSSProperties}
            >
                {newsItems.map((news, index) => (
                    <SwiperSlide key={index}>
                        <div className="min-w-full box-border mt-[70px] px-6 w-[calc(100%-1.5rem)]">
                            <h2 className="an-h2 text-white">{news.title}</h2>
                            <p className="an-body text-white mt-3" dangerouslySetInnerHTML={{__html: sanitizeHtml(news.description)}}></p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </Box>
    );
};

export default NewsSlider;
